import React from "react";
import { Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import {
  VENTANA_ASEOS_ABIERTOS_DIAS,
  textoVentanaAbiertos,
} from "../../../utils/ventanaAseosAbiertos";

const { Text } = Typography;

/**
 * Nota discreta sobre la lista de «Aseos abiertos» de la aseadora (round 2026-10-28): solo ve
 * los de los próximos N días (N configurable, 14 por defecto; llega del servidor); los más
 * lejanos se habilitan a medida que se acercan. El admin ve todos los abiertos, así que a él no
 * se le muestra (lo decide quien la monta).
 */
const AvisoVentanaAbiertos: React.FC<{ dias?: number }> = ({
  dias = VENTANA_ASEOS_ABIERTOS_DIAS,
}) => (
  <div
    data-testid="aviso-ventana-abiertos"
    style={{ margin: "0 0 10px", display: "flex", gap: 6, alignItems: "flex-start" }}
  >
    <InfoCircleOutlined style={{ color: "var(--text-muted, #64748B)", marginTop: 3 }} />
    <Text type="secondary" style={{ fontSize: 13 }}>
      {textoVentanaAbiertos(dias)}
    </Text>
  </div>
);

export default AvisoVentanaAbiertos;
